/** @jsxRuntime classic */
/** @jsx jsx */
import {jsx, css} from '@emotion/react'
import {Table, TableBody, TableCell, TableRow} from '@material-ui/core'
import {RouteComponentProps} from '@reach/router'
import {useFormik} from 'formik'
import {toast} from 'react-toastify'
import {Box} from 'reoil'
import BtnBottom from '../components/BtnBottom'
import Navigation from '../components/Navigation'
import {ResponseData} from '../hooks/api/types'
import useFetchSurvey from '../hooks/api/useFetchSurvey'
import {useThemeValue} from '../store/themeState'
import fetcher from '../utils/fetcher'
import goto from '../utils/goto'
import {responseBoxProp} from '../utils/propsHelpers'

const SurveyPage: React.FC<RouteComponentProps> = () => {
  const {data} = useFetchSurvey()
  const theme = useThemeValue()

  const desc = data?.data[0]?.title

  const part1Desc = data?.data[1]?.title
  const part2Desc = data?.data[2]?.title

  const user = data?.data[3] as
    | undefined
    | {
        username: string
        gender: string
        major: string
        education: string
      }

  const part1Questions = data?.data.filter(item => item.type === 'part1')
  const part2Questions = data?.data.filter(item => item.type === 'part2')

  const formik = useFormik({
    initialValues: {},
    // 提交表单
    async onSubmit(values) {
      const psychology = Object.entries(values).map(([k, v]) => ({
        serial: k,
        selected: v
      }))

      console.log(psychology)
      // TODO: 等接口完成
      const res: ResponseData<unknown> = await fetcher.post(
        'psychology.php?a=save',
        {psychology}
      )

      if (res.success) {
        toast('提交成功', {type: 'success'})
        goto(-1)
      }
    }
  })

  return (
    <Box stretch pb={6}>
      <Navigation title='心理测试' hideAvatar height={59} />

      {data && (
        <Box
          {...responseBoxProp}
          p={3}
          css={css`
            white-space: pre-wrap;
            word-break: break-all;
            box-sizing: border-box;
            background-color: ${theme.colors.background.base};

            p.desc {
              line-height: 1.5;
              font-size: 14px;
              color: ${theme.colors.text.body2};
            }

            hr {
              border: none;
              border-bottom: 1px solid whitesmoke;
              width: 100%;
              margin: 20px 0;
            }

            h3 {
              color: ${theme.colors.primary};
              margin: 20px 0 10px;
            }
          `}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>姓名:</TableCell>
                <TableCell>{user?.username}</TableCell>
                <TableCell>性别:</TableCell>
                <TableCell>{user?.gender}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>学历:</TableCell>
                <TableCell>{user?.education}</TableCell>
                <TableCell>专业:</TableCell>
                <TableCell>{user?.major}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <p className='desc' dangerouslySetInnerHTML={{__html: desc ?? ''}} />
          <hr />
          <form
            onSubmit={formik.handleSubmit}
            css={css`
              line-height: 1.8;

              .ask {
                margin: 10px 0;
              }

              input {
                margin-right: 10px;
              }
            `}>
            <h3>一、{part1Desc}</h3>
            {part1Questions?.map((item, i) => (
              <Box className='question' key={item.serial} mb={3}>
                <Box className='ask' fontWeight='bold'>
                  {i + 1}.{item.title}
                </Box>
                {item.Aselect && (
                  <label>
                    <input
                      type='radio'
                      name={item.serial}
                      value='A'
                      onChange={formik.handleChange}
                    />
                    <span>{item.Aselect}</span>
                  </label>
                )}
                {item.Bselect && (
                  <label>
                    <input
                      type='radio'
                      name={item.serial}
                      value='B'
                      onChange={formik.handleChange}
                    />
                    <span>{item.Bselect}</span>
                  </label>
                )}
                {item.Cselect && (
                  <label>
                    <input
                      type='radio'
                      name={item.serial}
                      value='C'
                      onChange={formik.handleChange}
                    />
                    <span>{item.Cselect}</span>
                  </label>
                )}
              </Box>
            ))}

            <h3>二、{part2Desc}</h3>
            {part2Questions?.map((item, i) => (
              <Box
                className='question'
                row
                center
                left
                key={item.serial}
                mb={3}
                lineHeight={1.2}>
                <Box
                  className='ask'
                  fontWeight='bold'
                  style={{marginRight: 20}}
                  minWidth={40}>
                  {i + 1}.{item.title}
                </Box>
                <Box
                  css={css`
                    display: grid;
                    flex: 1;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 10px;
                    align-items: center;

                    input {
                      margin-right: 4px;
                    }
                  `}>
                  {item.Aselect && (
                    <label>
                      <input
                        type='radio'
                        name={item.serial}
                        value='A'
                        onChange={formik.handleChange}
                      />
                      <span>{item.Aselect}</span>
                    </label>
                  )}
                  {item.Bselect && (
                    <label>
                      <input
                        type='radio'
                        name={item.serial}
                        value='B'
                        onChange={formik.handleChange}
                      />
                      <span>{item.Bselect}</span>
                    </label>
                  )}
                  {/* {item.Cselect && (
                    <label>
                      <input
                        type='radio'
                        name={item.serial}
                        value='C'
                        onChange={formik.handleChange}
                      />
                      <span>{item.Cselect}</span>
                    </label>
                  )} */}
                </Box>
              </Box>
            ))}
          </form>
        </Box>
      )}

      <BtnBottom disabled={false} onClick={() => formik.submitForm()}>
        提交
      </BtnBottom>
    </Box>
  )
}

export default SurveyPage
